import QuestCreateUpdate from "./QuestCreateUpdate.jsx";
import ListQuest from "./ListQuest.jsx";
import ViewQuestStop from "./ViewQuestStop.jsx";

export default {
  QuestCreateUpdate,
  ListQuest,
  ViewQuestStop
}
